import Image from 'next/image';
import { storeFutuExchange } from "@/shared/store/exchange"
import ChartFuture from "./ChartFutures"
import { storeFutuWSMarket } from "@/features/ticker/model/useTickerStore"
import { storeFutuUserInfo } from "@/shared/store/userInfo"
import useCountdownTimer from "@/shared/hooks/futures/useCountDown"
import { MODAL } from '@/shared/utils/const';
import { ConvetDotSize } from '@/shared/utils/formatter';
import { useEffect } from 'react';

interface ChartModalProps {
  onClose: () => void
}

const ChartModal = ({ onClose }: ChartModalProps) => {
  const { exSymbol, getTickSize } = storeFutuExchange()
  const { ticker24, headerInfo } = storeFutuWSMarket()
  const { interval, setInterval } = storeFutuUserInfo()

  // 차트 모달이 열릴 때 인터벌을 명시적으로 설정
  useEffect(() => {
    // 인터벌이 비어있거나 잘못된 값인 경우 기본값 설정
    if (!interval || interval === '') {
      setInterval('60') // 기본값을 1시간으로 설정
    }
  }, [interval, setInterval])

  const exSymbolTicker = ticker24.get(exSymbol)
  const exSymbolName = exSymbol.split('USDT')[0]
  // const exSymbolVol = ConvetDotSize(exSymbolTicker?.q ?? '', 2)
  const exSymbolLast = ConvetDotSize(exSymbolTicker?.c ?? '', getTickSize(exSymbol))
  const exSymbolChange = ConvetDotSize(String(exSymbolTicker?.p ?? ''), getTickSize(exSymbol))
  const exSymbolChangePercent = exSymbolTicker?.P ?? ''

  const exSymbolFundingRate = headerInfo?.fundingFee ?? ''
  const countdownTime = useCountdownTimer(headerInfo.nextFundingTime)

  return (
    <div className="modal-page chart-modal">
      <div className="chart-modal-header">
        <button onClick={onClose} className="flex-1 w-[18px] h-full">
          <Image src={MODAL.mo.backClose} width={18} height={18} alt="chart back" />
        </button>
        <div className="chart-symbol-wrap">
          <div className="col text-left">
            <p className="font-semibold text-[16px] tracking-[-0.25px] text-font-basic">{exSymbolName}</p>
            <p className="text-[11px]  tracking-[-0.25px] text-font-gray">perpetual</p>
          </div>
          <div className="col text-right">
            <p className={`font-semibold text-[14px] tracking-[-0.25px] ${Number(exSymbolChange) >= 0 ? 'text-chart-long' : 'text-chart-short'}`}>
              {exSymbolLast}
            </p>
            <p className={`text-[11px]  tracking-[-0.25px] ${Number(exSymbolChange) >= 0 ? 'text-chart-long' : 'text-chart-short'}`}>
              {exSymbolChangePercent}%
              ({exSymbolChange})
            </p>
          </div>
          <div className="col text-right">
            <p className="font-semibold text-[14px] tracking-[-0.25px] text-font-basic">{exSymbolFundingRate}</p>
            <p className="text-[11px]  tracking-[-0.25px] text-font-gray">{countdownTime}</p>
          </div>
        </div>
      </div>
      <div className="chart-modal-body  mo-gray-divider border-b">
        <ChartFuture />
      </div>
    </div>
  )
}

export default ChartModal